module.exports = "pegasus/assets/blocks/column-10-tech.png";